import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { DatePicker } from "antd";
import Loading from "../../loader/loader";
import MultipleSelect from "./multipleSelect";
import NkHeader from "../../../common/nkheader";
import NkTable from "../../users/nktable";
import SectionOne from "./SectionOne";
import TransactionDetailsPopup from "./TransactionDetailsPopup";
import moment from "moment";

// import HeaderPart from "../commonheader.js";

const RaktransactionsPresentational = ({
  transactionDetails,
  setFiltersSelected,
  rowOnClick,
  setCurrentTransactionId,
  setTransactionDetailModel,
  updateStatusClicked,
  updateloading,
  transactionData,
  filterValues,
  fromDate = null,
  setFromDate,
  toDate,
  setToDate,
  setTransactionDetailsShow,
  transactionDetailsShow,
  FilterSelect,
  setModalShow,
  noOfFiltersSelected,
  setNoOfFiltersSelected,
  resetFilter,
  handleFIlter,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  allUserListExcel,
  columns,
  columnsCsv,
  pagination,
  setFilterForm,
  setSizeShow,
  modalShow,
  handleChange,
  handleChange1,
  handleChange2,
  options,
  options1,
  options2,
  filtersSelected,
  selectedOption,
  selectedOption1,
  selectedOption2,
  statusFilter,
  typeFilter,
  transactionDetailModel,
  
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  type,
  country,
  status,
  setType,
  setCountry,
  setStatus,
  filterLength,
  setFilterLength
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  console.log("noOfFiltersSelected", noOfFiltersSelected);
  return (
    <>
      <Container fluid>
        <NkHeader title="RAK Transactions" />
        <SectionOne
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          setModalShow={setModalShow}
          filtersSelected={filtersSelected}
          noOfFiltersSelected={noOfFiltersSelected}
          resetFilter={resetFilter}
          handleFIlter={handleFIlter}
          filterForm={filterForm}
        />
        {filterValues && transactionData.length <= 0 ? (
          <>
            <Card
              className="mb-4"
              style={{
                display: "flex",
                flex: 1,
                textAlign: "center",
                justifyContent: "center",
                padding: "1.25rem 1.5rem",
              }}
            >
              <CardBody>
                <h1 className="mb-0">Sorry ! We cannot find it</h1>
                <h3 className="mb-0">
                  Enter a different search term or remove any filters and try
                  again
                </h3>
              </CardBody>
            </Card>
          </>
        ) : (
          <>
            <Row>
              <div className="col card-parent">
                <Card style={{ padding: "1.25rem 1.5rem" }}>
                  {dataLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Loading />
                    </div>
                  ) : (
                    <>
                      <NkTable
                        dataexcal
                        filename={"rak-profile"}
                        data={transactionData}
                        buttonRef={buttonRef}
                        type="raktransaction"
                        rowOnClick={rowOnClick}
                        filterdata={filterForm}
                        onExcelClciked={() => onExcelClciked(filterForm)}
                        dataEXCEL={allUserListExcel}
                        columns={columns}
                        columnsCsv={columnsCsv}
                        pagination={pagination}
                        onPagechange={(page) => {
                          setFilterForm({
                            ...filterForm,
                            page: page,
                          });
                        }}
                        showSizeChanged={(pageSize) => {
                          setSizeShow(pageSize);
                          setFilterForm({
                            ...filterForm,
                          });
                        }}
                      />
                    </>
                  )}
                </Card>
              </div>
            </Row>
          </>
        )}
      </Container>
      <MultipleSelect
      filterLength={filterLength}
      setFilterLength={setFilterLength}
        saveButtonClicked={(saveResponse) => {
          console.log("saveResponse", saveResponse);
          let request = { ...filterForm, ...saveResponse, isFilter: false };
          setFilterForm({ ...request });
          setModalShow(false);
          setFiltersSelected(true);
    

          let totalLength = saveResponse.totalLength;
          console.log("totalLength", totalLength);
          
        }}
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        typeFilter={typeFilter}
        selectedOption={selectedOption}
        selectedOption1={selectedOption1}
        selectedOption2={selectedOption2}
        options={options}
        options1={options1}
        options2={options2}
        handleChange={handleChange}
        handleChange1={handleChange1}
        handleChange2={handleChange2}
        type={type}
        setType={setType}
        country={country}
        setCountry={setCountry}
        status={status}
        setStatus={setStatus}
        setNoOfFiltersSelected={setNoOfFiltersSelected}
      />
      <TransactionDetailsPopup
        show={transactionDetailModel}
        transactionDetails={transactionDetails}
        updateStatusClicked={updateStatusClicked}
       updateloading={updateloading}
        onHide={() => {setCurrentTransactionId("");setTransactionDetailModel(false)}}
      />
    </>
  );
};

export default RaktransactionsPresentational;
